import React, { useState, useEffect } from "react";
import { animateScroll as scroll } from "react-scroll";
import { FaBars } from "react-icons/fa";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinkR,
  NavLinks,
} from "./NavbarElements";

const Navbar = ({ toggle, isOpen }) => {
  const [scrollNav, setScrollNav] = useState(false);

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNav);
    return () => {
      window.removeEventListener("scroll", changeNav);
    };
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <>
      <Nav scrollNav={scrollNav} isOpen={isOpen}>
        <NavbarContainer>
          <NavLogo to="/" onClick={toggleHome}>
            Roza Venerini
          </NavLogo>
          <MobileIcon onClick={toggle}>
            <FaBars />
          </MobileIcon>
          <NavMenu>
            <NavItem>
              <NavLinks
                to="about"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                Despre noi
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks
                to="mission"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                Misiune
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks
                to="groups"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                Grupe
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks
                to="vision"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                Viziune
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks
                to="offer"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                Oferta
              </NavLinks>
            </NavItem>

            <NavItem>
              <NavLinkR to="/documente">Documente</NavLinkR>
            </NavItem>

            <NavItem>
              <NavLinkR to="/galerie">Galerie</NavLinkR>
            </NavItem>
          </NavMenu>
        </NavbarContainer>
      </Nav>
    </>
  );
};

export default Navbar;
